import { render, staticRenderFns } from "./AlbumPicker.vue?vue&type=template&id=1a54bf93&scoped=true"
import script from "./AlbumPicker.vue?vue&type=script&lang=js"
export * from "./AlbumPicker.vue?vue&type=script&lang=js"
import style0 from "./AlbumPicker.vue?vue&type=style&index=0&id=1a54bf93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a54bf93",
  null
  
)

export default component.exports